import { Stack } from '@mui/material'
import React from 'react'

import { TestSuiteComposition } from 'components/test-suites/forms/test-suite-composition/TestSuiteComposition'
import { TestSuiteName } from 'components/test-suites/forms/TestSuiteName'
import { TestSuiteUnderstandingScoreCalculation } from 'components/test-suites/forms/TestSuiteUnderstandingScoreCalculation'
import { type Team } from 'types/api/teams'

export const CreateTestSuiteAddTests: React.FC<{
  teams: Team[]
}> = ({ teams }) => {
  return (
    <Stack spacing={4}>
      <TestSuiteName />
      <TestSuiteComposition teams={teams} />
      <TestSuiteUnderstandingScoreCalculation />
    </Stack>
  )
}
